declare const I18n;

import React from 'react';

type Props = {
  courseId: string;
  learnersCourseCompleted: number
  totalLearners: number
}



const CompletedMetric: React.FunctionComponent<Props> = ({courseId, learnersCourseCompleted, totalLearners
}: Props): JSX.Element => {
  return (
    <div className='sidebar-metrics'>
      <p>{I18n.t("models.course.metrics.learners_course_completion")}</p>
      <div className="sidebar-metrics__robot_and_item">
        <img
          src="/robot.svg"
          alt="Robot Icon"
          width={70}
          height={70}
        />
        <p>{`${learnersCourseCompleted}/${totalLearners}`}</p>
      
      </div>
      <a href={`/courses/${courseId}/learners`}>{I18n.t("models.learner.learner_courses.view_learner_progress")}</a>
    </div>
  )

}

export default CompletedMetric;